/**
 * Model to hold country data.
 */
export class Country {
    public id: string;
    public name: string;
    public abbreviation: string;

    public clone(): Country {
        const clone: Country = new Country();
        clone.id = this.id;
        clone.name = this.name;
        clone.abbreviation = this.abbreviation;
        return clone;
    }

    /**
   * Serialize from a json api format
   */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'country';
        json.data.id = this.id;
        json.data.attributes = {};
        json.data.attributes.name = this.name;
        json.data.attributes.abbreviation = this.abbreviation;
        return JSON.stringify(json);
    }

    /**
   * Deserialize to a json api format
   */
    public deserialize(json: Object): Country {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'];

        this.id = data['id'];
        this.name = attrs['name'];
        this.abbreviation = attrs['abbreviation'];

        return this;
    }
}
